import { render, staticRenderFns } from "./CardInterface.vue?vue&type=template&id=a410c930&scoped=true&"
import script from "./CardInterface.vue?vue&type=script&lang=js&"
export * from "./CardInterface.vue?vue&type=script&lang=js&"
import style0 from "./CardInterface.vue?vue&type=style&index=0&id=a410c930&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a410c930",
  null
  
)

export default component.exports